import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 5em);
  margin-top: 2em;
  display: flex;

  p {
    font-family: "Poppins";
  }

  /* Estilos específicos para o container com id="tools" */
  &#tools {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
    display: none; /* Será alterado para flex via JavaScript */
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
`;

export const Menu = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  background-color: rgba(5, 7, 10);

  .btn {
    width: max-content;
    height: 2em;
    border-bottom: 4px solid rgb(130, 185, 42, 0.5);
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.03);
    opacity: 0.6;
    border-right: 1px solid ${({ theme }) => theme.card};
    padding: 0 15px;
    margin: 0 15px;
    cursor: pointer;

    &:hover,
    &.ativ {
      opacity: 0.9;
    }
    p {
      font-size: 0.75em;
    }

    svg {
      width: 2em;
      font-size: 0.4em;
      margin-right: 10px;
    }
  }
`;

export const Cards = styled.div`
  width: 100%;
  min-height: 7em;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.contrast};
  align-items: center;
  justify-content: center;
  transform: translateY(0.5em);
`;

export const Card = styled.div`
  width: calc(100% / 6);
  height: 6em;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.custom2};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.border5};
  margin-left: 1.35em;
  margin-right: 1em;
  .header {
    width: 100%;
    min-height: 2em;
    border-bottom: 1px solid ${({ theme }) => theme.card};
    display: flex;
    align-items: center;

    p {
      font-size: 13px;
      margin-left: 15px;
      opacity: 0.6;
    }
  }

  .content {
    margin-left: 1em;
    width: 100%;
    margin-left: 15px;
    font-size: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    opacity: 0.9;
  }
`;

export const ReportDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 3em;
`;

export const Relatorio = styled.div`
  width: 100%;
  min-height: calc(100vh - 13em);
  display: flex;
  align-items: center;
  justify-content: center;

  .block {
    width: 97%;
    height: 95%;
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.body2};
    border: 1px solid ${({ theme }) => theme.border5};
    margin-right: 5px;
    border-radius: 5px;

    .data {
      /* Ajuste de largura para a coluna "Data" */
      min-width: 14em !important;
    }

    .numeroNfe {
      /* Ajuste de largura para a coluna "Número NFE" */
      min-width: 12em !important;
    }

    .chave {
      min-width: 28em !important;
    }

    .status {
      min-width: 12em !important;
    }

    .cnpj {
      min-width: 16em !important;
    }

    .emitente {
      /* Ajuste de largura para a coluna "Emitente" */
      min-width: 20em !important;
    }

    .check {
      width: 3em;
      display: flex;
      align-items: center;
      justify-content: center;

      &.download {
        width: 4em;
        cursor: pointer;
        opacity: 0.5;
        transition: all 0.2s;

        &:hover {
          opacity: 1;
        }
      }

      svg {
        color: white;
      }

      .thumb {
        width: 0.5em;
        height: 0.5em;
        border-radius: 100%;
        border: 1px solid ${({ theme }) => theme.border};
        background-color: rgba(0, 0, 0, 0.05);

        &.white {
          background-color: transparent;
        }
      }
    }

    .head {
      width: 100%;
      height: 3em;
      display: flex;
      align-items: center;
      border-bottom: 1px solid ${({ theme }) => theme.card2};
      justify-content: space-between;
      background-color: ${({ theme }) => theme.custom4};

      /* ... demais estilos de .head (botões, search etc.) ... */
    }

    .table {
      width: 100%;
      height: calc(100% - 3em);
      display: flex;
      flex-direction: column;
      position: relative; /* Added for proper positioning */

      .head {
        width: 100%;
        height: 1.7em;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: ${({ theme }) => theme.card4};
        position: sticky; /* Keep table header visible too */
        top: 0;
        z-index: 5;

        p {
          font-size: 0.8em;
        }

        .colum {
          width: max-content;
          height: 100%;
          display: flex;
          align-items: center;
          min-width: 3em;

          p {
            font-size: 0.75em;
            opacity: 0.7;
          }

          svg {
            margin: 0 5px;
            margin-left: 10px;
            opacity: 0.7;
          }
        }
      }

      /* Removemos width:120% para não esticar a tabela */
      .display {
        width: 100%;
        height: calc(100% - 1.7em);
        background-color: ${({ theme }) => theme.load};
        overflow-y: auto; /* Mantém o scroll */
        margin-bottom: 20px;
        /* Set a max-height to ensure scrolling happens within this container */
        max-height: calc(
          100vh - 20em
        ); /* Adjust this value based on your layout */

        .items {
          width: 100%;
          min-height: 4em;
          display: flex;
          align-items: center;
          background-color: ${({ theme }) => theme.card};
          margin: 1px 0;
          border-radius: 5px;
          opacity: 0.8;
          cursor: pointer;
          transition: all 0.1s;

          &:hover {
            opacity: 1;
          }

          .item {
            height: 100%;
            display: flex;
            align-items: center;

            p {
              font-size: 0.9em;
              margin-left: 8px;
              opacity: 1;
            }

            /* Ajustes de largura nas classes correspondentes */
            &.data {
              width: 14em !important;
            }
            &.numeroNfe {
              width: 12em !important;
            }
            &.chave {
              width: 28em !important;
            }
            &.status {
              width: 12em !important;
            }
            &.cnpj {
              width: 16em !important;
            }
            &.emitente {
              width: 20em !important;
            }

            &.check {
              width: 3em;
              justify-content: center;
            }

            &.check.download {
              width: 4em;
              cursor: pointer;
              opacity: 0.5;
              transition: all 0.2s;

              &:hover {
                opacity: 1;
              }
            }
          }
        }

        .no-results {
          width: 100%;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            font-size: 0.9em;
            opacity: 0.7;
          }
        }

        .loading-more {
          width: 100%;
          padding: 1em 0;
        }
      }

      .empty-state {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .message {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;

          p {
            font-size: 0.9em;
            opacity: 0.7;
          }
        }
      }

      .no-results {
        width: 100%;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          font-size: 0.9em;
          opacity: 0.7;
        }
      }
    }
  }
`;

export const Thumb = styled.div`
  width: 0.5em;
  height: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.border2};
  background-color: ${({ check, theme }) => (check ? "green" : theme.card)};
  svg {
    font-size: 1em;
    color: ${({ check }) => (check ? "white" : "inherit")};
  }
`;
